/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
* */

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import {WealthyEnv} from "helpers";
import {colors} from "nxtconstants";

const downArrow = `${WealthyEnv.HOMEPAGE_CDN_URL}/arrow-down.png`;

const propTypes = {
  content: PropTypes.string,
  setToggled: PropTypes.bool,
  title: PropTypes.string,
  toggled: PropTypes.bool
};

const defaultProps = {
  title: "",
  content: ""
};

const AccordianItem = ({
  title,
  content,
  toggled,
  setToggled
}) => {
  return (
    <FaqItem className={`${toggled ? "toggled" : ""}`}>
      <FaqItemWrapper
        role="presentation"
        onClick={() => setToggled(!toggled)}
      >
        <FaqTitle>{title}</FaqTitle>
        <ArrowDownIcon>
          <img
            alt="toggleAccordian"
            src={downArrow}
          />
        </ArrowDownIcon>
      </FaqItemWrapper>
      <FaqDescription className="content">
        <FaqContent>
          {content}
        </FaqContent>
      </FaqDescription>
    </FaqItem>
  );
};

const FaqItem = styled.div`
  background-color: ${colors.alabaster};
  border-radius: 2px;  
  &:not(:last-child) {
    margin-bottom: 2rem;
  }
  &.toggled {
    img {
      transform: rotate(180deg);
    }
    .content {
      height: auto;
      max-height: 9999px;
      transition: all 0.5s cubic-bezier(1,0,1,0);
    }
  }
`;

const FaqItemWrapper = styled.div`
  padding: 2.2rem 3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  img {
    height: 1.2rem;
    transition: all 0.2s ease-in-out;
  }

  @media (max-width: 576px) {
    padding: 1rem 2rem;
    line-height: 1.8;
  }
`;

const FaqTitle = styled.h3`
  font-weight: 400;
  color: ${colors.textGray};
  font-size: 1.8rem;

  @media (max-width: 576px) {
    font-size: 1.4rem;
  }
`;

const ArrowDownIcon = styled.div``;

const FaqDescription = styled.div`
  overflow: hidden;
  max-height: 0;
  height: 0;
  transition: all 0.5s cubic-bezier(0,1,0,1);
`;

const FaqContent = styled.p`
  padding: 0 3rem 2.2rem;
  color: ${colors.textBlack};
  font-size: 1.6rem;
  line-height: 1.8;

  @media (max-width: 576px) {
    padding: 0 2rem 1rem;
    text-align: justify;
  }
`;

AccordianItem.propTypes = propTypes;
AccordianItem.defaultProps = defaultProps;

export default AccordianItem;
